import { css } from '@emotion/css';
import THEME from './colors';

export const antdPrefixCls = 'ant5';

export const cursorPointer = css`
  cursor: pointer;
`;
export const textCenter = css`
  text-align: center;
`;
export const width100 = css`
  width: 100%;
`;

export const height100 = css`
  height: 100%;
`;
export const rowParted = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &.content {
    background: #ffffff;
    margin: 16px;
  }
`;

export const cssPopover = css`
  .${antdPrefixCls}-popover-arrow {
    display: none;
  }
  .${antdPrefixCls}-popover-content {
    .${antdPrefixCls}-popover-inner {
      border-radius: 2px;
      padding: 0px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
      overflow: hidden;
      .${antdPrefixCls}-popover-inner-content {
        padding: 0px;
      }
    }
  }
`;

export const cssModal = css`
  .${antdPrefixCls}-modal-content {
    background-color: ${THEME.background};
    padding: 0;
    border-radius: 4px;
  }
  .${antdPrefixCls}-modal-body {
    padding: 0;
  }
`;

export const cssDot = ({ c, w = 8 }: { c: string; w?: number }) => css`
  width: ${w}px;
  height: ${w}px;
  border-radius: 50%;
  background-color: ${c};
`;

export const styleTooltip = css`
  &.${antdPrefixCls}-tooltip {
    padding-bottom: 0;
    max-width: 400px;
    max-height: 400px;
    overflow-y: auto;
  }

  .${antdPrefixCls}-tooltip-arrow {
    display: none;
  }

  .${antdPrefixCls}-tooltip-inner {
    background: #fff;
    color: ${THEME.secondary};
    padding: 8px 12px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 12px;
    white-space: pre-wrap;
  }
`;

export const styleShowingOnHover = (cls: string) => css`
  .${cls} {
    opacity: 0;
  }
  &:hover {
    .${cls} {
      opacity: 1;
    }
  }
`;

export const styleBoxCenter = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const cssBrandingBoldText = css`
  b {
    color: ${THEME.branding};
  }
`;

export const cssSearchHighlight = css`
  .highlight {
    color: ${THEME.branding};
  }
`;

export const alignMiddle = css`
  vertical-align: middle;
`;

export const maxContentWidth = css`
  width: max-content;
`;

export const cssPageLayoutContainer = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .page-content {
    margin: 16px;
    flex: 1;
    overflow: auto;
    border-radius: 4px;
    background: ${THEME.background};
  }
`;

export const cssWordBreakSelect = css`
  .${antdPrefixCls}-select-item-option-content {
    white-space: pre-line !important;
    word-break: break-all !important;
  }
`;

export const modalWrapClassName = css`
  .${antdPrefixCls}-modal-confirm-paragraph {
    row-gap: 0px;
  }
  .${antdPrefixCls}-modal-confirm-body-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    ::before,
    ::after {
      display: none;
    }
  }
  .${antdPrefixCls}-modal-confirm-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .${antdPrefixCls}-modal-confirm-paragraph {
      max-width: unset;
    }
  }
  .${antdPrefixCls}-modal-content {
    padding: 0px;
    border-radius: 4px;
    background: ${THEME.background};
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  }
  .${antdPrefixCls}-modal-confirm-title {
    min-height: 50px;
    line-height: 50px;
    width: 100%;
    padding: 0px 32px 0 16px;
    border-bottom: 1px solid #e2e5e7;
    display: flex;
    align-items: center;
    &:not(:has(.${antdPrefixCls}-modal-close)) {
      padding-right: 16px;
    }

    > div {
      white-space: pre;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .${antdPrefixCls}-modal-confirm-content {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    border-bottom: 1px solid ${THEME.fourth};
  }

  .${antdPrefixCls}-modal-confirm-btns {
    margin: 0px !important;
    padding: 12px 16px;
  }

  .${antdPrefixCls}-modal-close {
    top: 14px;
    inset-inline-end: 16px;
  }
`;

export const modalMultiLinesTitle = css`
  padding: 13px 0;
  line-height: 24px;
`;
